import React from "react";
import { Tabs as MuiTabs, Tab, Box, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { tokens } from "../../theme";
import { RootState } from "../../store/Index";

export interface TabItem {
  label: string;
  value: string | number;
  disabled?: boolean;
}

export interface TabsProps {
  items: TabItem[];
  value: string | number;
  onChange: (value: string | number) => void;
  trailing?: React.ReactNode;
}

const Tabs: React.FC<TabsProps> = ({ items, value, onChange, trailing }) => {
  const theme = useTheme();
  const reduxTheme = useSelector((state: RootState) => state.theme);
  const colors = tokens(theme.palette.mode, reduxTheme);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderBottom: `1px solid ${colors.primary[300]}30`,
      }}
    >
      <MuiTabs
        value={value}
        onChange={(_, v) => onChange(v)}
        TabIndicatorProps={{
          sx: {
            backgroundColor: colors.primary[400],
            height: 3,
            borderRadius: 2,
          },
        }}
        sx={{ minHeight: "40px" }}
      >
        {items.map((item) => (
          <Tab
            key={item.value}
            label={item.label}
            value={item.value}
            disabled={item.disabled}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              fontSize: "0.85rem",
              minHeight: "40px",
              "&.Mui-selected": { color: colors.primary[400] },
            }}
          />
        ))}
      </MuiTabs>
      {trailing}
    </Box>
  );
};

export default Tabs;
